

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete, Button, Confirm, Form, Grid, Input, Modal, Panel, Validation,
} from 'framework-ui-components';
import KeyCodes from 'enums/KeyCodes';
import {
  abilitaSostitutoImposta, sostitutoImposta, creaSostitutoImposta, modificaSostitutoImposta, casisticaModificaSostitutiImpostaDaDichiarazioni, ottieniSostitutoImposta,
} from 'apis/sostitutiApi';

Validation.register('TelefonoONumeroVerdeValido', (x, y) => !telefonoONumeroVerdeValido(x), { message: 'Telefono non valido' });

export const telefonoONumeroVerdeValido = (telefono) => {
  // se vuota i dati sono validi
  if (telefono === null || telefono === undefined) {
    return true;
  }
  // se non è una stringa non è un numero di cellualre valido
  if (typeof (telefono) !== 'string') {
    return false;
  }
  if (telefono.length === 0) {
    return true;
  }
  telefono.replace(/ /g, '');
  if (telefono.match(/^[+]?[0|3]{1}[1-9]+[-\s/]?[0-9]{5,}|[8]{1}[0-9]{2}[-\s/]?[0-9]{6}$/i)) {
    return true;
  }

  return false;
};

const FORM_INITIAL_STATE = {
  IdSostitutoImpostaEsistente: -1,
  CodiceFiscale: '',
  Denominazione: '',
  CodiceSede: '0',
  CodiceComune: '',
  DescrizioneComune: '',
  CodiceProvincia: '',
  TipologiaIndirizzo: '',
  Indirizzo: '',
  NumeroCivico: '',
  Cap: '',
  Frazione: '',
  Telefono: '',
  Fax: '',
  EMail: '',
  Centralizzato: false,
  Dismesso: false,
  ForzaModifica: false,

};


class ModaleSostituto extends Component {
  state = {
    ...FORM_INITIAL_STATE,
    caricandoModale: false,
    confermaDisabled: true,
    visualizzaErrori: false,
    msgErrori: '',
    codiceSedeDisabled: false,
    JSONOriginale: '',
  }

  componentDidMount() {
    this.cfInput && this.cfInput.focus();
    if (this.props.idSostituto != -1) {
      this.caricaSostituto(this.props.idSostituto);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.idSostituto != -1) {
      this.caricaSostituto(nextProps.idSostituto);
    }
  }

  caricaSostituto = (idSostituoDaCaricare) => {
    sostitutoImposta(idSostituoDaCaricare)
      .then((res) => {
        if (res) {
          this.setState({
            IdSostitutoImpostaEsistente: res.IdSostituto,
            CodiceFiscale: res.CodiceFiscale,
            Denominazione: res.Denominazione,
            CodiceSede: res.CodiceSede,
            CodiceComune: res.CodiceComune,
            DescrizioneComune: res.DescrizioneComune,
            CodiceProvincia: res.CodiceProvincia,
            TipologiaIndirizzo: res.TipologiaIndirizzo,
            Indirizzo: res.Indirizzo,
            NumeroCivico: res.NumeroCivico,
            Cap: res.Cap,
            Frazione: res.Frazione,
            Telefono: res.Telefono,
            Fax: res.Fax,
            EMail: res.EMail,
            Centralizzato: res.Centralizzato,
            Dismesso: res.Dismesso,
            codiceSedeDisabled: res.CodiceSede != 0,
            visualizzaErrori: false,
            msgErrori: '',
          });
          const obj = {
            IdSostitutoImpostaEsistente: res.IdSostituto,
            CodiceFiscale: res.CodiceFiscale,
            Denominazione: res.Denominazione,
            CodiceSede: res.CodiceSede,
            CodiceComune: res.CodiceComune,
            DescrizioneComune: res.DescrizioneComune,
            CodiceProvincia: res.CodiceProvincia,
            TipologiaIndirizzo: res.TipologiaIndirizzo,
            Indirizzo: res.Indirizzo,
            NumeroCivico: res.NumeroCivico,
            Cap: res.Cap,
            Frazione: res.Frazione,
            Telefono: res.Telefono,
            Fax: res.Fax,
            EMail: res.EMail,
            Centralizzato: res.Centralizzato,
            Dismesso: res.Dismesso,
          };

          this.setState({ JSONOriginale: JSON.stringify(obj) });

          this.valutaAbilitaConferma();
        }
      });
  }

  abilitaCaricaSostituto = (idSostituto) => {
    abilitaSostitutoImposta(idSostituto)
      .then((res) => {
        if (res.Success) {
          // this.props.idSostituto = idSostituto;
          this.caricaSostituto(idSostituto);
        }
      });
  }

  incolla = (e) => {
    const str = e.clipboardData.getData('Text');
    e.preventDefault();
    this.setState({ CodiceFiscale: str.trim() });
  }

  valutaEsistenzaSostituto = (evt) => {
    const { value } = evt.target;
    ottieniSostitutoImposta(value, this.props.ufficioSelezionato, this.state.CodiceSede)
      .then((res) => {
        if (res) {
          if (res.Centralizzato) {
            const msg = 'I dati del sostituto d’imposta INPS sono già memorizzati negli archivi: è sufficiente richiamarlo dal quadro sostituto d’imposta del 730: vuoi visualizzarli?';
            Confirm('Sostituto esistente', msg, 'warning').then(() => this.caricaSostituto(res.IdSostituto), () => { this.annulla(); });
          }
        }
        this.valutaAbilitaConferma();
      });
  }

  valutaEsistenzaSostitutoDaSede = (evt) => {
    const { value } = evt.target;
    ottieniSostitutoImposta(this.state.CodiceFiscale, this.props.ufficioSelezionato, value)
      .then((res) => {
        if (res) {
          if (res.Dismesso) {
            const msg = `Il sostituto con codice fiscale ${res.CodiceFiscale} e codice sede ${res.CodiceSede} è presente ma è disabilitato. Vuoi abilitare il sostituto e modificarlo?`;
            Confirm('Sostituto esistente', msg, 'warning').then(() => this.abilitaCaricaSostituto(res.IdSostituto), () => { this.annulla(); });
          } else {
            const msg = `Il sostituto con codice fiscale ${res.CodiceFiscale} e codice sede ${res.CodiceSede} è già presente in archivio. Vuoi modificarlo?`;
            Confirm('Sostituto esistente', msg, 'warning').then(() => this.caricaSostituto(res.IdSostituto), () => { this.annulla(); });
          }
        } else {
          this.valutaAbilitaConferma();
        }
      });
  }


  valutaAbilitaConferma = () => {
    const obj = {
      IdSostitutoImpostaEsistente: this.state.IdSostitutoImpostaEsistente,
      CodiceFiscale: this.state.CodiceFiscale,
      Denominazione: this.state.Denominazione,
      CodiceSede: this.state.CodiceSede,
      CodiceComune: this.state.CodiceComune,
      DescrizioneComune: this.state.DescrizioneComune,
      CodiceProvincia: this.state.CodiceProvincia,
      TipologiaIndirizzo: this.state.TipologiaIndirizzo,
      Indirizzo: this.state.Indirizzo,
      NumeroCivico: this.state.NumeroCivico,
      Cap: this.state.Cap,
      Frazione: this.state.Frazione,
      Telefono: this.state.Telefono,
      Fax: this.state.Fax,
      EMail: this.state.EMail,
      Centralizzato: this.state.Centralizzato,
      Dismesso: this.state.Dismesso,
    };
    if (!this.state.Centralizzato && !this.state.Dismesso
      && this.state.JSONOriginale != JSON.stringify(obj)) {
      this.setState({ confermaDisabled: false });
    } else {
      this.setState({ confermaDisabled: true });
    }
  }

  annulla = () => {
    this.setState(FORM_INITIAL_STATE, () => this.props.onAnnulla && this.props.onAnnulla());
  }

  conferma = () => {
    const { TipologiaIndirizzo, CodiceComune } = this.state;
    if (this.form.valida() && TipologiaIndirizzo && CodiceComune) {
      ottieniSostitutoImposta(this.state.CodiceFiscale, this.props.ufficioSelezionato, this.state.CodiceSede)
        .then((res) => {
          if (res) {
            if (this.state.IdSostitutoImpostaEsistente != -1 && res.IdSostituto == this.state.IdSostitutoImpostaEsistente) {
              casisticaModificaSostitutiImpostaDaDichiarazioni(this.props.ufficioSelezionato, this.state.CodiceFiscale, this.state.CodiceSede, this.props.annoSelezionato)
                .then((res) => {
                  if (res == 0 || res == 1) {
                    this.creaAggiornaSostituto();
                  } else {
                    let testo = '';
                    if (res == 2 || res == 4) {
                      testo = "La modifica verrà riportata in tutte le dichiarazioni nelle quali è stato indicato questo sostituto d'imposta. "
                        + 'Vuoi riportare la modifica anche nelle dichiarazioni con stato Controllo Audit e Trasmessa CGN (che verranno impostate come da stampare)? ';
                      Confirm('Aggiornamento dichiarazioni', testo, 'warning').then(() => this.creaAggiornaSostituto(true), () => this.creaAggiornaSostituto(false));
                    } else if (res == 5 || res == 7) {
                      testo = "La modifica verrà riportata in tutte le dichiarazioni nelle quali è stato indicato questo sostituto d'imposta. "
                        + 'Non verrà riportata nelle dichiarazioni in stato Inviata A.E., Ricevuta A.E., Da annullare A.E, Annullata A.E. e/o Bloccata CAF. '
                        + 'Vuoi riportare la modifica anche nelle dichiarazioni con stato Controllo Audit e Trasmessa CGN (che verranno impostate come da stampare) ?';
                      Confirm('Aggiornamento dichiarazioni', testo, 'warning').then(() => this.creaAggiornaSostituto(true));
                    } else if (res == 3 || res == 6) {
                      testo = "La modifica non verrà riportata nelle dichiarazioni nelle quali è stato indicato questo sostituto d'imposta "
                        + 'aventi stato Inviata A.E., Ricevuta A.E., Da annullare A.E, Annullata A.E., e/o Bloccata CAF.';
                      Confirm('Aggiornamento dichiarazioni', testo, 'warning').then(() => this.creaAggiornaSostituto(false));
                    }
                  }
                });
            } else if (res.Centralizzato) {
              const msg = 'I dati del sostituto d’imposta INPS sono già memorizzati negli archivi: è sufficiente richiamarlo dal quadro sostituto d’imposta del 730: vuoi visualizzarli?';
              Confirm('Sostituto esistente', msg, 'warning').then(() => this.caricaSostituto(res.IdSostituto), () => { this.annulla(); });
            } else if (res.Dismesso) {
              const msg = `Il sostituto con codice fiscale ${res.CodiceFiscale} e codice sede ${res.CodiceSede} è presente ma è disabilitato. Vuoi abilitare il sostituto e modificarlo?`;
              Confirm('Sostituto esistente', msg, 'warning').then(() => this.abilitaCaricaSostituto(res.IdSostituto), () => { this.annulla(); });
            } else {
              const msg = `Il sostituto con codice fiscale ${res.CodiceFiscale} e codice sede ${res.CodiceSede} è già presente. Vuoi modificare il sostituto esistente?`;
              Confirm('Sostituto esistente', msg, 'warning').then(() => this.caricaSostituto(res.IdSostituto), () => { this.annulla(); });
            }
          } else {
            this.creaAggiornaSostituto(false);
          }
        });
    }
  }

  creaAggiornaSostituto = (forzaModifica) => {
    const cmd = {
      IdSostituto: this.state.IdSostitutoImpostaEsistente,
      Cap: this.state.Cap,
      CodiceComune: this.state.CodiceComune,
      CodiceFiscale: this.state.CodiceFiscale,
      CodiceSede: this.state.CodiceSede,
      CodiceUfficio: this.props.ufficioSelezionato,
      Denominazione: this.state.Denominazione,
      EMail: this.state.EMail,
      Fax: this.state.Fax,
      Frazione: this.state.Frazione,
      Indirizzo: this.state.Indirizzo,
      NumeroCivico: this.state.NumeroCivico,
      Telefono: this.state.Telefono,
      TipologiaIndirizzo: this.state.TipologiaIndirizzo,
      ForzaModifica: forzaModifica,
    };
    if (this.state.IdSostitutoImpostaEsistente == -1) {
      creaSostitutoImposta(cmd)
        .then((res) => {
          if (res.Success) {
            this.annulla();
          } else {
            this.setState({ visualizzaErrori: true, msgErrori: res.DetectedProblems });
          }
        });
    } else {
      // Aggiornamento sostituto imposta
      modificaSostitutoImposta(cmd)
        .then((res) => {
          if (res.Success) {
            this.annulla();
          } else {
            this.setState({ visualizzaErrori: true, msgErrori: res.DetectedProblems });
          }
        });
    }
  }

  updateForm = (data) => {
    this.setState(data, () => {
      this.valutaAbilitaConferma();
    });
  }

  onChangeComune = (data) => {
    this.setState({
      CodiceComune: data.CodiceComune, CodiceProvincia: data.CodiceProvincia, DescrizioneComune: data.Descrizione, Cap: data.Cap,
    }, () => { this.valutaAbilitaConferma(); });
  }

  onChangeTipoIndirizzo = (data) => {
    this.setState({ TipologiaIndirizzo: data.Descrizione }, () => { this.valutaAbilitaConferma(); });
  }

  isNumeriLettereBarraMeno = (evt) => {
    if (!((evt.keyCode >= 47 && evt.keyCode <= KeyCodes.NineDigit)
      || evt.keyCode === 45
      || (evt.keyCode >= 65 && evt.keyCode <= 90)
      || (evt.keyCode >= 97 && evt.keyCode <= 122))
      && !(evt.keyCode >= 96 && evt.keyCode <= 105)) {
      // permetto Ctrl+A, Ctl+C, Ctrl+V, Ctrl+X ma nessun altro tasto
      if (evt.keyCode === KeyCodes.A || evt.keyCode === KeyCodes.V
        || evt.keyCode === KeyCodes.C || evt.keyCode === KeyCodes.X) {
        if (!evt.ctrlKey) {
          evt.preventDefault();
        }
      } else if (evt.keyCode !== KeyCodes.Delete && evt.keyCode !== KeyCodes.Backspace && evt.keyCode !== KeyCodes.Tab && evt.keyCode !== KeyCodes.Dash) {
        evt.preventDefault();
      }
    }
    if (evt.shiftKey && (evt.keyCode >= KeyCodes.ZeroDigit && evt.keyCode <= KeyCodes.NineDigit)) {
      if (evt.keyCode != 55) { // lo slash come shift+7 è ammesso
        evt.preventDefault();
      }
    }
  };

  render() {
    const { showModal, idSostituto, visualizza = false } = this.props;
    const {
      caricandoModale, confermaDisabled, visualizzaErrori, msgErrori, codiceSedeDisabled, TipologiaIndirizzo, DescrizioneComune, Centralizzato, IdSostitutoImpostaEsistente, Dismesso,
    } = this.state;

    return (
      <Modal show={showModal} onClose={this.annulla} loading={caricandoModale} className="modaleSostitutoDialog">
        <Modal.Header>
          {idSostituto == -1 ? 'Nuovo sostituto di imposta' : 'Modifica sostituto di imposta'}
        </Modal.Header>
        <Modal.Body>
          <Form stato={this.state} onChange={this.updateForm} ref={r => this.form = r}>
            <Grid fluid className="pl-0 pr-0">
              <Grid.Row>
                <Grid.Col md="4">
                  <Input
                    name="CodiceFiscale"
                    title="Codice fiscale"
                    disabled={visualizza || IdSostitutoImpostaEsistente != -1}
                    validations={['required', 'CodiceFiscale']}
                    onPaste={this.incolla}
                    onBlur={this.valutaEsistenzaSostituto}
                    ref={r => this.cfInput = r}
                    maxLength="16"
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="6">
                  <Input
                    name="Denominazione"
                    title="Cognome e nome o denominazione"
                    validations={['required']}
                    disabled={visualizza || Centralizzato || Dismesso}
                    onChange={this.valutaAbilitaConferma}
                    maxLength="500"
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="2">
                  <Input
                    name="CodiceSede"
                    title="Codice Sede"
                    disabled={visualizza || idSostituto != -1}
                    onBlur={this.valutaEsistenzaSostitutoDaSede}
                    validations={['required', { rule: 'Pattern', pattern: new RegExp('^[0-9]'), message: 'Codice sede formalmente non corretto. Valore compreso tra 0 e 999.' }]}
                    maxLength="3"
                    upperCase
                    format="number"
                  />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="3">
                  <Autocomplete
                    title="Comune"
                    minLength={2}
                    validations={['required']}
                    onChange={this.onChangeComune}
                    renderProperty="Descrizione"
                    renderRow={null}
                    disabled={visualizza || Centralizzato || Dismesso}
                    title="Comune"
                    url="/api/V1/SostitutoImposta/CercaComune"
                    value={DescrizioneComune}
                  />
                </Grid.Col>
                <Grid.Col md="1">
                  <Input
                    name="CodiceProvincia"
                    title="Prov."
                    disabled
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="3">
                  <Autocomplete
                    title="Tipo indirizzo"
                    minLength={2}
                    validations={['required']}
                    onChange={this.onChangeTipoIndirizzo}
                    renderProperty="Descrizione"
                    renderRow={null}
                    disabled={visualizza || Centralizzato || Dismesso}
                    title="Tipo indirizzo"
                    url="/api/V1/SostitutoImposta/CercaTipoIndirizzo"
                    value={TipologiaIndirizzo}
                  />
                </Grid.Col>
                <Grid.Col md="4">
                  <Input
                    name="Indirizzo"
                    validations={['required']}
                    title="Indirizzo"
                    maxLength="255"
                    disabled={visualizza || Centralizzato || Dismesso}
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="1">
                  <Input
                    name="NumeroCivico"
                    title="Civico"
                    maxLength="10"
                    disabled={visualizza || Centralizzato || Dismesso}
                    upperCase
                    onKeyDown={this.isNumeriLettereBarraMeno}
                  />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="2">
                  <Input
                    name="Cap"
                    title="C.A.P."
                    maxLength="5"
                    disabled={visualizza || Centralizzato || Dismesso}
                    validations={['required']}
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="4">
                  <Input
                    name="Frazione"
                    title="Frazione"
                    maxLength="100"
                    disabled={visualizza || Centralizzato || Dismesso}
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="3">
                  <Input
                    name="Telefono"
                    title="Numero di telefono"
                    maxLength="20"
                    validations={['TelefonoONumeroVerdeValido']}
                    disabled={visualizza || Centralizzato || Dismesso}
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="3">
                  <Input
                    name="Fax"
                    title="Numero di fax"
                    maxLength="20"
                    validations={['Fax']}
                    disabled={visualizza || Centralizzato || Dismesso}
                    upperCase
                  />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="6">
                  <Input
                    name="EMail"
                    title="E-Mail"
                    maxLength="50"
                    validations={['Email']}
                    disabled={visualizza || Centralizzato || Dismesso}
                    upperCase
                  />
                </Grid.Col>
                <Grid.Col md="6">
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="12">
                  {
                    visualizzaErrori
                    && (
                      <Panel
                        error
                        title="Errore"
                      >{msgErrori}
                      </Panel>
                    )
                  }
                </Grid.Col>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button primary={visualizza} flat onClick={this.annulla}>{visualizza ? 'Chiudi' : 'Annulla'}</Button>
          {!visualizza && <Button flat primary onClick={this.conferma} disabled={confermaDisabled}>Conferma</Button>}
        </Modal.Footer>
      </Modal>
    );
  }
}

ModaleSostituto.propTypes = {
  idSostituto: PropTypes.number.isRequired,
  ufficioSelezionato: PropTypes.string.isRequired,
  onAnnulla: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequire,
  annoSelezionato: PropTypes.number,
};


export default ModaleSostituto;
